export default {
    grok: { "rawSubmit": '内容将原样提交，由服务方处理并返回结果。', "unavailableTitle": '暂未开放', "step2": '提交 Grok sso', "ssoLabel": "Grok sso 登录凭据", "placeholder": "粘贴 grok.com 的 sso、Cookie 头或包含 sso 的 JSON", "guide": "登录 grok.com，在浏览器开发者工具的 Application / 存储 → Cookies → grok.com 中复制完整 sso。它是敏感登录凭据，请勿公开分享。", "accountPending": "处理后获取账号信息", "countryHint": "将按此地区账单地址开通，不检查账号的计费币种。", "promo": "首月优惠", "eligible": "可享", "ineligible": "不可享", "disabled": "Grok 兑换暂未开放，请稍后刷新或联系客服。" },
    common: {
        retryAfter: '请求过于频繁，请等待 {seconds} 秒后重试。',
        documentTitle: 'GPT兑换站',
        back: '← 返回',
        backHome: '← 返回首页',
        loading: '加载中...',
        submitting: '提交中...',
        querying: '查询中...',
        retry: '重新查询',
        selectPlaceholder: '请选择',
    },
    language: {
        switchToEnglish: '切换到英文',
        switchToChinese: '切换到中文',
    },
    home: {
        brand: 'Service Portal',
        brandSub: 'Account Upgrade Service',
        heroTitle: '充值与账户升级服务',
        heroSub: '按步骤校验账号、卡密并确认信息',
        sectionDescriptions: {
            recharge: '验证兑换卡密并提交账号 Session，完成一次安全、可追踪的充值申请。',
            query: '输入一个或多个 CDK，快速查看任务状态与处理进度。',
            subscription: '实时查看账号订阅套餐、到期时间和自动续费状态。',
            refresh: '在符合条件时更换卡密，请及时保存新的卡密。',
            cancel: '取消仍在排队、尚未开始处理的充值任务。',
        },
        flowTitle: '操作流程',
        tabsAria: '兑换站功能',
        announcementLabel: '公告',
        announcementAria: '兑换页公告',
        services: {
            recharge: { title: '充值提交', en: 'Service Portal', cta: '开始充值', p1: '验证 CDK 卡密', p2: '提交 Session', p3: '确认提交申请' },
            lookup: { title: '任务查询', en: 'Task Lookup', cta: '查询状态', p1: '通过 CDK 查询', p2: '查看任务状态', p3: '跟踪处理进度' },
        },
        flows: {
            submit: { title: '提交流程', s1: 'CDK 验证 — 检查卡密状态', s2: '提交 Session — 粘贴 chatgpt.com/api/auth/session 的 JSON', s3: '确认提交 — 阅读协议后确认' },
            lookup: { title: '查询流程', s1: '输入 CDK — 输入购买时使用的 CDK', s2: '查询任务 — 点击查询按钮', s3: '查看状态 — 展示对应任务状态' },
        },
    },
    queue: {
        pendingLabel: '后台待处理',
        unit: '个任务',
        loading: '同步中',
        syncing: '实时同步中',
        polling: '定时同步中',
        reconnecting: '连接断开，自动重连中',
    },
    recharge: {
        batchModeAria: '充值模式',
        singleMode: '单张充值',
        batchMode: '批量充值',
        maintenanceTitle: '充值服务提示',
        billingCountry: '适用账单地区',
        billingCountryHint: '请使用在此地区计费的账号；已有订阅的计费币种不匹配时，任务会被拒绝。',
        billingCountryUnrestricted: '此卡密未限定账单地区。',
        noCountryRestriction: '不限地区',
        serviceClosed: '兑换暂时关闭',
        keepPageOpen: '支付过程中可能需要完成一次人机验证，请保持页面打开。',
        subscriptionAdvisoryChecking: '正在查询订阅状态供您核对，不影响下一步。',
        subscriptionAdvisoryUnavailable: '暂时无法确认账号订阅状态，您仍可提交，由服务端处理时核验。',
        subscriptionAdvisoryActive: '查询到当前账号订阅：{plan}。能否使用此卡密，由服务端处理时核验。',
        subscriptionAdvisoryProvider: '账号状态仅供参考，最终兑换资格由服务端处理时核验。',
        channelLabel: '充值通道',
        title: '充值提交',
        subtitle: 'Service Portal · 账号充值申请',
        steps: { s1: 'CDK 验证', s2: '提交 Session', s3: '确认提交' },
        step1Title: '验证 CDK 卡密',
        cdkLabel: 'CDK 卡密',
        cdkValid: '✓ CDK 有效',
        cdkPending: '该卡密正在处理中',
        cdkPendingHint: '正在自动检测，若任务失败将自动恢复为可提交，无需刷新页面',
        planType: '套餐类型',
        verifying: '验证中...',
        verifyButton: '验证 CDK',
        next: '下一步 →',
        prev: '← 上一步',
        restart: '重新兑换',
        step2Title: '提交 Session',
        progressAria: '充值进度',
        sessionGuidePrefix: '登录 ChatGPT 后，在浏览器打开',
        sessionGuideSuffix: '，将页面返回的完整 JSON 全部复制，粘贴到下方输入框。',
        sessionGuideTitle: '3 步正确获取 Session',
        sessionGuideSubtitle: '请使用需要充值的账号，并按以下顺序操作',
        sessionGuideBadge: '3 步完成',
        sessionGuideStep1: '登录 ChatGPT，确认当前登录的是需要充值的账号。',
        sessionGuideStep2: '保持登录状态，在同一浏览器中打开',
        sessionGuideOpenLink: 'Session 获取页面',
        sessionGuideStep3: '页面显示 JSON 后，按 Ctrl/Cmd+A 全选、Ctrl/Cmd+C 复制，再完整粘贴到下方输入框。',
        sessionGuideAutoCheck: '粘贴后自动检查完整 Session 格式。订阅查询仅供参考，实际兑换资格由服务端处理时核验。',
        sessionGuideRenewalAutoCheck: '粘贴后系统会自动检查 Session 格式；提交后由充值后端校验有效性。',
        sessionGuideTrouble: '页面为空、显示 null 或提示未登录？请重新登录 ChatGPT，然后再次打开 Session 页面。',
        sessionGuideNoticeTitle: '安全提醒：',
        sessionGuideNotice: '必须复制完整 JSON，不要只复制 accessToken。Session 含敏感登录信息，请勿发送给他人。',
        sessionLabel: 'Session JSON',
        step3Title: '确认提交',
        sessionStatus: 'Session 状态',
        sessionFilled: '✓ 已填写',
        sessionChecking: '正在实时查询账号订阅状态...',
        sessionFreeVerified: '✓ Session 已验证，符合当前卡密提交条件',
        sessionFormatValid: '✓ Session 格式检查通过，提交后由充值后端校验有效性',
        submitSuccessTitle: '✓ 申请已提交成功！',
        taskId: '任务ID',
        submitSuccessHint: '任务进度会自动更新。支付过程中可能需要人机验证，请保持页面打开。',
        confirmSubmit: '确认提交',
        errInvalidCdk: 'CDK无效',
        errVerifyFailed: '验证失败',
        errCreateFailed: '创建任务失败',
        errConfirmFailed: '提交失败',
        errNetwork: '网络错误',
        errSessionRequired: '请粘贴完整的 Session JSON',
        errSessionInvalidJson: 'Session JSON 格式不正确，请复制完整 JSON 后再提交',
        errSessionMissingAccessToken: 'Session JSON 格式不完整：未找到 accessToken',
        errSessionMissingSessionToken: 'Session JSON 格式不完整：未找到 sessionToken',
        errSessionMissingEmail: 'Session JSON 格式不完整：未找到账号邮箱',
        errSessionPlanNotFree: '实时查询到当前账号套餐为 {planType}，不符合当前卡密的提交条件',
        errSessionActiveSubscription: '当前账号套餐与卡密套餐同级或更高，无法提交',
        errSessionPlanUnknown: '暂时无法确认账号的有效订阅状态，请稍后重试',
        errRechargePlanUnknown: '暂时无法识别卡密套餐，请重新验证卡密或联系管理员',
        errQuotaAccountNotEligible: '当前账号不符合此额度卡的使用条件，请核对卡密适用套餐',
        errSessionCheckFailed: '订阅状态查询失败，请稍后重试',
        errSessionCheckRequired: 'Session 尚未通过当前卡密的实时套餐校验，请重新查询',
        errSessionFormatCheckRequired: 'Session 尚未通过格式检查，请检查完整 JSON 后重试',
        refreshCdk: '换码（剩余 {count} 次）',
        refreshSuccess: '换码成功，新卡密已更新',
        refreshFailed: '换码失败，请稍后重试',
    },
    history: {
        bankVerificationNeeded: '需要完成银行验证，请点开此任务',
        verificationNeeded: '需要人机验证，请点开此任务',
        replaced: '卡密已更换',
        queryFailed: '暂时无法查询任务，请稍后重试；已有订单请勿重复提交。',
        title: '任务查询',
        subtitle: 'Task Lookup · 通过 CDK 查询当前充值任务状态',
        queryTitle: '卡密查询',
        queryHint: '输入购买时使用的 CDK 卡密，系统会在当前页面展示对应任务状态。',
        queryPlaceholder: '输入购买时使用的 CDK 卡密',
        batchQueryTitle: '批量卡密查询',
        batchQueryHint: '支持一次粘贴多条 CDK（最多 100 条），使用换行、空格、逗号或分号分隔；系统会自动去重并展示每条任务状态。',
        batchQueryPlaceholder: '每行一个 CDK，或用逗号分隔多条卡密',
        detectedCodes: '已识别 {count} 条唯一 CDK',
        clearQuery: '清空查询',
        cdkLabel: 'CDK 卡密',
        queryBtn: '查询任务',
        batchQueryBtn: '批量查询',
        queryErrorTitle: '查询失败',
        resultTitle: '查询结果',
        liveRefreshing: '处理中任务自动刷新中…',
        batchResultTitle: '批量结果',
        batchSummaryTitle: '查询概览',
        batchSummaryText: '已找到 {found}/{total} 条任务，{unused} 条未使用。',
        batchSummaryTextWithMissing: '已找到 {found}/{total} 条任务，{unused} 条未使用，{notFound} 条需核对。',
        batchStatsAria: '批量查询统计',
        totalQueried: '查询总数',
        foundCount: '已找到',
        processingCount: '处理中',
        failedCount: '失败',
        unusedCount: '未使用',
        notFoundCount: '需核对',
        batchListAria: '批量查询结果列表',
        accountUnknown: '账号未记录',
        unusedShort: '未使用',
        unusedHint: '该 CDK 尚未提交充值任务',
        unusedWithPlan: '未提交任务 · {plan}',
        notFoundShort: '未找到',
        copyUnused: '复制未使用',
        copyUnusedSuccess: '已复制 {count} 条未使用的 CDK。',
        copyUnusedFailed: '复制失败，请手动复制。',
        maxBatchExceeded: '一次最多支持查询 {max} 条 CDK，请拆分后再试。',
        taskId: '任务ID',
        cdkCode: 'CDK 卡密',
        subscriptionType: '订阅类型',
        rechargeAccount: '充值账号',
        currentStatus: '当前状态',
        failureReason: '失败原因',
        detailTitle: '任务明细',
        submitTime: '提交时间',
        completeTime: '完成时间',
        queryOther: '查询其他任务',
        detailActionsAria: '任务操作',
        copyCdk: '复制卡密',
        copyAccount: '复制账号',
        resubmit: '重新提交',
        refreshCdk: '换码',
        cancelTask: '取消排队任务',
        cancelTaskConfirm: '确定取消这笔尚未开始处理的任务吗？取消后可以重新提交。',
        cancelTaskSuccess: '任务已取消，卡密已恢复可提交',
        cancelTaskFailed: '取消失败，请刷新状态后重试',
        copyCdkSuccess: '已复制卡密',
        copyAccountSuccess: '已复制账号',
        copyActionFailed: '复制失败，请手动复制',
        selectTaskTitle: '选择任务查看详情',
        selectTaskHint: '点击左侧任意一条已找到的任务，这里会显示完整明细。',
        notFoundTitle: '未找到该 CDK 对应的任务',
        notFoundHint: '请检查 CDK 是否输入正确',
        msgPending: '⏳ 任务正在等待处理，请耐心等待...',
        msgSubmitted: '⚙ 任务正在处理中，请稍候...',
        msgConfirming: '准备或充值结果正在核对，请查询原订单，勿重复提交。',
        msgManualReview: '⏳ 后台处理中，请稍作等待...',
        msgCompleted: '✓ 任务已完成，您的账号已成功升级',
        msgFailed: '✗ 任务处理失败，请重新提交或联系客服',
        resultHeadline: { pending: '等待用户确认', submitted: '后台正在处理', confirming: '充值结果确认中', manual_review: '后台处理中', completed: '充值已完成', failed: '充值处理失败' },
        status: { pending: '待处理', submitted: '处理中', confirming: '充值结果确认中', manual_review: '后台处理中', completed: '已完成', failed: '失败' },
    },
    refresh: {
        title: '换卡',
        feedbackTitle: '换卡提示',
        hint: '仅未使用或任务失败的卡可换，每张最多 3 次、间隔 60 秒。成功后旧卡失效。',
        check: '查询换卡资格',
        checking: '查询中...',
        submit: '确认换卡',
        submitting: '换卡中...',
        clear: '清空',
        remaining: '可换卡次数：{count}',
        notEligible: '该卡密当前不满足换卡条件',
        failed: '换卡失败',
        success: '换卡成功，请立即保存新卡密',
        saveWarning: '新卡密只会在这里展示一次，请复制保存。',
        oldCode: '旧卡密',
        newCode: '新卡密',
        copy: '复制新卡密',
        copySuccess: '新卡密已复制',
        batch: {
            cooldownWaiting: '请等待 {seconds} 秒后重试',
            closedQualification: '兑换暂时关闭，暂时无法确认换码资格和剩余次数；可确认提交换码，由服务端判断是否允许。',
            notChecked: '因请求限流，本张尚未查询，请等待后重新查询。',
            deferredStatus: '等待服务端判断',
            modeAria: '换卡模式',
            singleMode: '单张换卡',
            batchMode: '批量换卡',
            title: '批量换卡',
            hint: '先逐张查询换卡资格，再确认派发。每次只发送一个请求，结果请及时保存。',
            inputLabel: '批量输入卡密',
            placeholder: '每行一个卡密，也支持空格、英文或中文逗号、分号分隔',
            inputHint: '大小写不敏感去重，保留首次写法，最多 100 张。无资格、处理中或次数为 0 的卡会跳过。',
            detected: '已识别 {count} 张唯一卡密',
            inputErrorTitle: '无法开始批量查询',
            empty: '请先输入至少一张卡密。',
            maxExceeded: '一次最多支持 {max} 张卡密，请拆分后再试。',
            check: '批量查询资格',
            recheck: '重新检查资格',
            checking: '查询中...',
            clear: '清空',
            retryFailed: '重试失败项（{count}）',
            summary: '待确认 {ready} 张 · 成功 {success} 张 · 失败 {failed} 张 · 结果未确认 {unknown} 张',
            listAria: '批量换卡结果列表',
            resultsTitle: '处理结果',
            remaining: '剩余 {count} 次',
            status: { checking: '查询中', ready: '符合资格', skipped: '跳过', verifyError: '资格查询失败', refreshing: '换卡中', success: '成功', failed: '明确失败', unknown: '结果未确认' },
            pending: '卡密正在处理中，已跳过。',
            notEligible: '该卡密当前不满足换卡条件。',
            verifyUnconfirmed: '资格查询未完成，可重试查询；尚未发送换卡。',
            businessFailed: '换卡请求被业务拒绝。可重新查询资格后再试。',
            unknownResult: '结果未确认，请先查询或联系管理员，勿重复换卡。',
            readyHint: '以下卡密已完成更换资格检查。',
            confirm: '确认批量换卡（{count}张）',
            confirmText: '确定批量换卡 {count} 张吗？换卡后旧卡立即失效，请保存新卡密；结果未确认时请勿重复换卡。',
            refreshing: '批量换卡中...',
            progress: '正在处理 {done}/{total}',
            complete: '完成：成功 {success} 张，失败 {failed} 张，结果未确认 {unknown} 张。',
            throttledTitle: '请求受到限制',
            throttled: '服务器返回频率限制，已停止继续派发。剩余符合资格的卡密仍可稍后手动确认继续。',
            copyAll: '复制全部新卡密',
            copySuccess: '已复制 {count} 张新卡密。',
            copyFailed: '复制失败，请手动复制；结果仍保留在列表中。',
            download: '下载 TXT',
            downloadSuccess: '结果 TXT 已下载。',
            discardConfirm: '还有未保存或结果未确认的批量换卡结果，确定清空并开始新的批次吗？',
        },
    },
    cancellation: {
        title: '取消任务',
        hint: '输入需要取消任务的 CDK 卡密。仅支持取消仍在排队、尚未开始处理的任务；取消成功后可重新提交充值。',
        clear: '清空',
        cancelling: '正在取消...',
    },
    subscription: {
        fieldRemainingValue: '剩余价值比例',
        plusPromo: 'Plus 半价促销',
        cancelRenewal: '取消自动续费',
        cancellingRenewal: '取消中…',
        cancelRenewalConfirm: '确定为账号 {account} 的 {plan} 取消自动续费吗？套餐可用到本期结束，到期后不再续订或扣费；不退款，也不会立即终止订阅。',
        cancelUnknown: '取消结果尚未确认，请先重新查询订阅状态；不会自动重复发送取消请求。',
        cancelFailed: '取消自动续费失败，请先查询订阅状态。',
        cancelSucceeded: '已取消自动续费，套餐可用到本期结束。',
        cancelRefreshFailed: '取消已成功，但订阅状态刷新失败，请重新查询。',
        title: '订阅查询',
        inputLabel: '输入 Session',
        inputPlaceholder: '粘贴 chatgpt.com/api/auth/session 的完整 JSON，或直接粘贴 accessToken',
        inputHint: '仅用于实时查询该账号的订阅状态，不会存储你的 Session。支持完整 session JSON 或 accessToken。',
        queryBtn: '查询订阅',
        clear: '清空',
        queryErrorTitle: '查询失败',
        queryFailed: '订阅查询失败，请重试',
        errInvalidInput: 'Session 格式不正确，请粘贴完整的 session JSON 或纯 accessToken',
        errInvalidSession: 'Session 无效或已过期，请重新获取后再试',
        errRateLimited: '查询过于频繁，请稍后再试',
        resultTitle: '订阅信息',
        statusActive: '当前订阅有效，自动续费已开启',
        statusCancelling: '当前订阅有效，但已关闭自动续费',
        statusInactive: '当前账号没有有效订阅',
        badgeActive: '订阅有效',
        badgeInactive: '无订阅',
        cancelledNotice: '已关闭自动续费，订阅将在到期后停止，不再扣费。',
        willRenewNotice: '自动续费已开启，将于 {date} 自动扣费续订。',
        inactiveNotice: '该账号当前没有有效订阅。',
        yes: '是',
        no: '否',
        renewOn: '已开启',
        renewOff: '已关闭',
        planFree: '免费版',
        detailTitle: '详细信息',
        fieldAccount: '当前账号',
        fieldPlan: '套餐',
        fieldActive: '订阅有效',
        fieldWillRenew: '自动续费',
        fieldExpires: '到期时间',
        fieldRemainingDays: '剩余天数',
        remainingDaysValue: '{days} 天',
        remainingDaysUnavailable: '暂无法计算',
        fieldRenews: '续费时间',
        fieldCancels: '取消生效时间',
        fieldBillingPeriod: '计费周期',
        fieldPlatform: '购买平台',
        periodMonthly: '每月',
        periodYearly: '每年',
        periodWeekly: '每周',
        platformWeb: 'ChatGPT 网页版',
        platformIos: 'iOS（App Store）',
        platformGoogle: 'Android（Google Play）',
    },
    login: {
        title: '管理员登录',
        subtitle: '登录后才能进入管理后台、CDK 管理和任务处理。',
        username: '用户名',
        usernamePlaceholder: '请输入用户名',
        password: '密码',
        passwordPlaceholder: '请输入密码',
        rememberPassword: '记住密码',
        rememberPasswordHint: '仅保存在当前浏览器，取消勾选会清除记录',
        loginBtn: '登录后台',
        loggingIn: '登录中...',
        errLoginFailed: '登录失败',
        errNetwork: '网络错误，请稍后重试',
    },
    notFound: {
        title: '页面不存在',
        home: '返回首页',
    },
};
